(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    function bindFullFrameSlideLinks() {
    document.querySelectorAll('slideshow-slide').forEach((slide) => {
      if (slide.dataset.fullFrameLinkBound) return;

      const link = slide.querySelector('.slide__content a[href]');
      if (!link) return;

      slide.dataset.fullFrameLinkBound = 'true';
      slide.addEventListener('click', (event) => {
        // Let the real link (or any other link inside the slide) behave normally
        if (event.target.closest('a')) return;

        if (link.target === '_blank') {
          window.open(link.href, '_blank', 'noopener');
        } else {
          window.location.href = link.href;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bindFullFrameSlideLinks);
  document.addEventListener('shopify:section:load', bindFullFrameSlideLinks);
  } catch(e) { console.error(e); }
})();

})();
